var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.interessado.espolio != null
        ? _c("app-display", {
            class:
              _vm.compararInteressado &&
              _vm.compararInteressado.mudouEspolioInteressados
                ? "text"
                : "",
            attrs: {
              label: "É espólio:",
              content: _vm.interessado.espolio ? "Sim" : "Não"
            }
          })
        : _vm._e(),
      _c("informacoes-pessoa", {
        attrs: {
          pessoa: _vm.interessado.pessoa,
          dadosInteressadoRr: _vm.dadosInteressadoRr,
          razaoSocialName: _vm.isOnerosoGroup
            ? "Razão Social:"
            : "Associação/Comunidade:",
          rendaFamiliar: _vm.interessado.rendaFamiliar,
          compararInformacoesPessoa:
            _vm.compararInteressado && _vm.compararInteressado.mudouPessoa,
          isProcessoFisico: _vm.isProcessoFisico
        }
      }),
      _vm.interessado.sociosRepresentantesLegais &&
      _vm.interessado.sociosRepresentantesLegais.length > 0
        ? _c(
            "app-collapse",
            {
              attrs: {
                title: _vm.labelSocioRepresentante.titleSocioRepresentante
              }
            },
            _vm._l(_vm.interessado.sociosRepresentantesLegais, function(
              socio,
              index
            ) {
              return _c(
                "app-collapse-child",
                {
                  key: socio.id,
                  attrs: { title: socio.pessoa.pessoaFisica.nome }
                },
                [
                  _c("informacoes-pessoa", {
                    attrs: {
                      pessoa: socio,
                      isSocio: true,
                      isSocioRepresentanteLegal: true,
                      razaoSocialName: _vm.isOnerosoGroup
                        ? "Razão Social:"
                        : "Associação/Comunidade:",
                      compararInformacoesPessoa:
                        _vm.compararInteressado &&
                        _vm.compararInteressado.mudouSocioRepresentanteLegal,
                      compararIsSocioRepresentanteLegal:
                        _vm.compararInteressado &&
                        _vm.compararInteressado.mudouSocioRepresentanteLegal
                    }
                  }),
                  socio.documentos && socio.documentos.length > 0
                    ? _c("listagem-documentos", {
                        attrs: {
                          documentos: socio.documentos,
                          protocoloCadastroOriginal:
                            _vm.cadastroOriginal.protocolo,
                          ownerDocumento: "SOCIO_REPRESENTANTE",
                          idSocio: socio._id || socio.id,
                          compararDocumentos:
                            _vm.compararInteressado &&
                            _vm.compararInteressado.mudouDocumentosInteressado,
                          versaoCadastro: _vm.versaoCadastro
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            }),
            1
          )
        : _vm._e(),
      !_vm.isReurb && !_vm.isProcessoFisico
        ? _c(
            "app-divider",
            { attrs: { label: "Endereço do Interessado" } },
            [
              _c("informacoes-endereco", {
                staticClass: "margin-top",
                attrs: {
                  slot: "body",
                  endereco: _vm.enderecoInteressado,
                  mudouEndereco:
                    _vm.compararInteressado &&
                    _vm.compararInteressado.mudouEndereco
                },
                slot: "body"
              })
            ],
            1
          )
        : _vm._e(),
      _vm.isBahia && _vm.enderecosCorrespondencia.length
        ? _c(
            "app-divider",
            { attrs: { label: "Endereços de Correspondência" } },
            _vm._l(_vm.enderecosCorrespondencia, function(
              enderecoCorrespondencia,
              index
            ) {
              return _c(
                "div",
                { key: index, attrs: { slot: "body" }, slot: "body" },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c("app-display", {
                        class:
                          _vm.compararInteressado &&
                          _vm.compararInteressado.mudouEndereco &&
                          _vm.compararInteressado.mudouEndereco
                            .mudouIdentificacao
                            ? "text"
                            : "",
                        staticStyle: {
                          "margin-bottom": "10px",
                          "margin-top": "20px"
                        },
                        attrs: {
                          label: "Identificacao:",
                          content:
                            index +
                              1 +
                              " - " +
                              enderecoCorrespondencia.identificacao || "-"
                        }
                      })
                    ],
                    1
                  ),
                  _c("informacoes-endereco", {
                    staticClass: "margin-top",
                    attrs: { endereco: enderecoCorrespondencia }
                  })
                ],
                1
              )
            }),
            0
          )
        : _vm.isBahia && _vm.interessado.pessoa.enderecoCorrespondencia
        ? _c(
            "app-divider",
            { attrs: { label: "Endereço de Correspondência" } },
            [
              _c("informacoes-endereco", {
                staticClass: "margin-top",
                attrs: {
                  slot: "body",
                  endereco: _vm.interessado.pessoa.enderecoCorrespondencia
                },
                slot: "body"
              })
            ],
            1
          )
        : _vm._e(),
      _vm.hasConjuge
        ? _c(
            "app-divider",
            { attrs: { label: "Cônjuge" } },
            [
              !_vm.isViuvo
                ? _c("informacoes-pessoa", {
                    staticClass: "margin-top",
                    attrs: {
                      slot: "body",
                      pessoa:
                        _vm.interessado.conjuge.pessoa ||
                        _vm.interessado.conjuge,
                      isConjuge: _vm.hasConjuge,
                      razaoSocialName: _vm.isOnerosoGroup
                        ? "Razão Social:"
                        : "Associação/Comunidade:",
                      compararInformacoesPessoa:
                        _vm.compararInteressado &&
                        _vm.compararInteressado.mudouConjugeInteressado,
                      isProcessoFisico: _vm.isProcessoFisico
                    },
                    slot: "body"
                  })
                : _c(
                    "div",
                    { attrs: { slot: "body" }, slot: "body" },
                    [
                      _c("app-display", {
                        class:
                          _vm.compararInteressado &&
                          _vm.compararInteressado.mudouPessoa
                            .mudouTemCertidaoObito
                            ? "text"
                            : "",
                        attrs: {
                          label: "Possui certidão de óbito?",
                          content: _vm.conjuge.temCertidaoObito ? "Sim" : "Não"
                        }
                      }),
                      _c("app-display", {
                        class:
                          _vm.compararInteressado &&
                          _vm.compararInteressado.mudouPessoa.mudouCPF
                            ? "text"
                            : "",
                        attrs: {
                          label: "CPF:",
                          content: _vm.conjuge.pessoaFisica.cpf
                        }
                      }),
                      _c("app-display", {
                        class:
                          _vm.compararInteressado &&
                          _vm.compararInteressado.mudouPessoa.mudouNome
                            ? "text"
                            : "",
                        attrs: {
                          label: "Nome:",
                          content: _vm.conjuge.pessoaFisica.nome
                        }
                      })
                    ],
                    1
                  )
            ],
            1
          )
        : _c("app-divider", { attrs: { label: "Cônjuge" } }, [
            _c(
              "div",
              {
                staticClass: "margin-top",
                attrs: { slot: "body" },
                slot: "body"
              },
              [
                _c("app-display", {
                  class:
                    _vm.compararInteressado &&
                    _vm.compararInteressado.mudouPossuiConjugeInteressado
                      ? "text"
                      : "",
                  attrs: { label: "Possui cônjuge?", content: "Não" }
                })
              ],
              1
            )
          ]),
      _vm.hasFamilia
        ? _c("app-divider", {
            class: _vm.compararInteressado.mudouMembroFamilia
              ? "text"
              : "titulo",
            attrs: { label: "Membros da família" }
          })
        : _vm._e(),
      _c(
        "div",
        [
          _c("app-membro-familia", {
            attrs: {
              membros: _vm.interessado.membrosFamilia,
              appMembroFamiliaComparar:
                _vm.compararInteressado &&
                _vm.compararInteressado.mudouMembroFamilia
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-57e24905", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57e24905","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/informacoesCadastro/InformacoesInteressado.vue
// module id = null
// module chunks = 